<template>
  <p-product-detail-block v-if="identitiesNotEmpty.length" data-test="identity" :title="'Fiche d\'identité'">
    <div class="product-detail-block-identity columns" data-test="identity-details">
      <div v-for="identity in identitiesNotEmpty" :key="identity.label">
        <div v-if="Array.isArray(identity.value)" class="product-detail-block-identity__item">
          <span v-if="identity.label">{{ `${identity.label} : ` }}</span>
          <ul class="columns">
            <li v-for="value in identity.value" :key="value" data-test="array-value">
              <strong>{{ value }}</strong>
            </li>
          </ul>
        </div>

        <div v-else class="product-detail-block-identity__item">
          <span v-if="identity.value">
            <span v-if="identity.label">{{ `${identity.label} : ` }}</span>
            <strong>{{ identity.value }}</strong>
          </span>
        </div>
      </div>
    </div>
  </p-product-detail-block>
</template>

<script lang="ts">
import { type PropType, computed, defineComponent } from 'vue'
import PProductDetailBlock from '../PProductDetailBlock/PProductDetailBlock.vue'
import type { Identity } from './typings'

export default defineComponent({
  name: 'PProductDetailBlockIdentity',
  props: {
    identities: {
      type: Array as PropType<Identity[]>,
      default: () => [],
    },
  },
  components: {
    PProductDetailBlock,
  },
  setup(props) {
    const { identities } = props

    const identitiesNotEmpty = computed(() =>
      identities.filter((object) => (Array.isArray(object.value) ? object.value.length : object.value)),
    )

    return {
      identitiesNotEmpty,
    }
  },
})
</script>

<style scoped lang="scss">
.product-detail-block-identity {
  margin: 0;

  li {
    list-style-type: none;
    padding-left: 20px;
  }

  &__item {
    display: inline-block;
  }
}

.columns {
  @media (min-width: $breakpoint-lg) {
    columns: 2;
  }
}
</style>
